// Caribbean islands. Base = V1 (French Antilles + Sint Maarten).
// V3 unlocks the rest of the Caribbean.
export const BASE_ISLANDS = [
  { v: "martinique", l: "Martinique", img: "https://images.unsplash.com/photo-1580223530509-849e0ad583ca?w=800&q=80" },
  { v: "guadeloupe", l: "Guadeloupe", img: "https://images.unsplash.com/photo-1778097866468-d1f0580da2fc?w=800&q=80" },
  { v: "saint-martin", l: "Saint-Martin", img: "https://images.unsplash.com/photo-1559825481-12a05cc00344?w=800&q=80" },
  { v: "sint-maarten", l: "Sint Maarten", img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80" },
];

const POOL = [
  "https://images.unsplash.com/photo-1541417904950-b855846fe074?w=800&q=80",
  "https://images.unsplash.com/photo-1618064541372-289bdb6f5b7b?w=800&q=80",
  "https://images.unsplash.com/photo-1504681869696-d977211a5f4c?w=800&q=80",
  "https://images.unsplash.com/photo-1619118986411-29b465253365?w=800&q=80",
];

export const V3_ISLANDS = [
  { v: "saint-barthelemy", l: "Saint-Barthélemy", img: POOL[0] },
  { v: "sainte-lucie", l: "Sainte-Lucie", img: "https://images.unsplash.com/photo-1710001222246-1c70c7feafe1?w=800&q=80" },
  { v: "dominique", l: "Dominique", img: POOL[2] },
  { v: "barbade", l: "Barbade", img: "https://images.unsplash.com/photo-1636728150922-e7361791595a?w=800&q=80" },
  { v: "grenade", l: "Grenade", img: POOL[1] },
  { v: "saint-vincent", l: "Saint-Vincent-et-les-Grenadines", img: POOL[3] },
  { v: "antigua", l: "Antigua-et-Barbuda", img: POOL[0] },
  { v: "saint-kitts", l: "Saint-Kitts-et-Nevis", img: POOL[2] },
  { v: "trinite-tobago", l: "Trinité-et-Tobago", img: POOL[1] },
  { v: "aruba", l: "Aruba", img: "https://images.unsplash.com/photo-1683782440921-823862401342?w=800&q=80" },
  { v: "curacao", l: "Curaçao", img: POOL[3] },
  { v: "bahamas", l: "Bahamas", img: "https://images.unsplash.com/photo-1562036861-44811e0b4481?w=800&q=80" },
  { v: "jamaique", l: "Jamaïque", img: "https://images.unsplash.com/photo-1707571854070-72028840176b?w=800&q=80" },
  { v: "republique-dominicaine", l: "République dominicaine", img: "https://images.unsplash.com/photo-1602608099803-96718a589bb3?w=800&q=80" },
  { v: "porto-rico", l: "Porto Rico", img: "https://images.unsplash.com/photo-1559313093-a25257adcadd?w=800&q=80" },
];

export const ALL_ISLANDS = [...BASE_ISLANDS, ...V3_ISLANDS];

export function islandsFor(v3) {
  return v3 ? ALL_ISLANDS : BASE_ISLANDS;
}

export function islandLabel(v) {
  return (ALL_ISLANDS.find((i) => i.v === v) || {}).l || v;
}

// Curated pickup points per island (airport, city center, port/marina, hotspot).
export const PICKUP_POINTS = {
  martinique: ["Aéroport Aimé Césaire (FDF)", "Fort-de-France centre", "Marina Le Marin", "Les Trois-Îlets"],
  guadeloupe: ["Aéroport Pôle Caraïbes (PTP)", "Pointe-à-Pitre centre", "Marina Bas-du-Fort", "Le Gosier"],
  "saint-martin": ["Aéroport de Grand-Case (SFG)", "Marigot centre", "Marina Fort Louis"],
  "sint-maarten": ["Princess Juliana Airport (SXM)", "Philipsburg centre", "Simpson Bay Marina"],
  "saint-barthelemy": ["Aéroport Gustaf III (SBH)", "Gustavia port", "Saint-Jean"],
  "sainte-lucie": ["Hewanorra Airport (UVF)", "Castries centre", "Rodney Bay Marina"],
  dominique: ["Douglas–Charles Airport (DOM)", "Roseau centre", "Portsmouth"],
  barbade: ["Grantley Adams Airport (BGI)", "Bridgetown centre", "Bridgetown Marina"],
  grenade: ["Maurice Bishop Airport (GND)", "St. George's centre", "Port Louis Marina"],
  "saint-vincent": ["Argyle Airport (SVD)", "Kingstown centre", "Blue Lagoon Marina"],
  antigua: ["V.C. Bird Airport (ANU)", "St. John's centre", "Jolly Harbour Marina"],
  "saint-kitts": ["R.L. Bradshaw Airport (SKB)", "Basseterre centre", "Christophe Harbour"],
  "trinite-tobago": ["Piarco Airport (POS)", "Port of Spain centre", "Crown Point (TAB)"],
  aruba: ["Reina Beatrix Airport (AUA)", "Oranjestad centre", "Palm Beach"],
  curacao: ["Hato Airport (CUR)", "Willemstad centre", "Jan Thiel"],
  bahamas: ["Nassau Airport (NAS)", "Nassau downtown", "Paradise Island"],
  jamaique: ["Sangster Airport (MBJ)", "Kingston (KIN)", "Montego Bay centre"],
  "republique-dominicaine": ["Punta Cana Airport (PUJ)", "Santo Domingo (SDQ)", "Puerto Plata (POP)"],
  "porto-rico": ["San Juan Airport (SJU)", "San Juan Viejo", "Ponce (PSE)"],
};

const GENERIC_PICKUP = ["Aéroport", "Centre-ville", "Port / Marina"];

export function pickupPointsFor(v) {
  return PICKUP_POINTS[v] || GENERIC_PICKUP;
}
